import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle} from 'lucide-react';
import config from '../utils/config';

export default function Footer() {
  return (
    <footer
      style={{
        background: 'var(--maroon)',
        color: 'rgba(255,255,255,0.8)',
        padding: '60px 24px 24px',
      }}
    >

    <div
      style={{
    maxWidth: 1200,
    margin: '0 auto 60px',
    background: 'linear-gradient(135deg,#7A2233,#4B101C)',
    border: '1px solid rgba(201,169,110,0.25)',
    borderRadius: 20,
    padding: '50px 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
  }}
>
  <div>
    <div
      style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: 38,
        color: '#C9A96E',
        marginBottom: 10,
      }}
    >
      Discover Timeless Elegance
    </div>

    <p
      style={{
        maxWidth: 500,
        opacity: 0.8,
        lineHeight: 1.8,
      }}
    >
      Explore jewellery designed for every occasion.
    </p>
  </div>

  <a
    href={config.whatsappUrl()}
    target="_blank"
    rel="noreferrer"
    className="btn btn-gold"
  >
    Chat on WhatsApp
  </a>
</div>


      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: 40,
          marginBottom: 40,
        }}
      >
        <div>
          <div
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontSize: 24,
              color: '#C9A96E',
              marginBottom: 12,
            }}
          >
            {config.brandName}
          </div>

          <p
            style={{
              fontSize: 13,
              lineHeight: 1.8,
              opacity: 0.7,
              maxWidth: 260,
            }}
          >
            Premium stainless steel jewellery brand crafting elegant pieces for every
            occasion. Tamilnadu, India.
          </p>

          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <a
              href={config.instagramUrl}
              target="_blank"
              rel="noreferrer"
              style={{
                width: 36,
                height: 36,
                border: '1px solid rgba(201,169,110,0.4)',
                borderRadius: '12px',
                transition: 'all .3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.6)',
              }}
              onMouseOver={(e)=>{
              e.currentTarget.style.background='#C9A96E';
              e.currentTarget.style.color='#4B101C';
            }}
            onMouseOut={(e)=>{
              e.currentTarget.style.background='transparent';
              e.currentTarget.style.color='rgba(255,255,255,0.6)';
            }}
            >
              <Instagram size={16} />
            </a>

            <a
              href={config.whatsappUrl()}
              target="_blank"
              rel="noreferrer"
              style={{
                width: 36,
                height: 36,
                border: '1px solid rgba(201,169,110,0.4)',
                borderRadius: '12px',
                transition: 'all .3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.6)',
              }}
              onMouseOver={(e)=>{
              e.currentTarget.style.background='#C9A96E';
              e.currentTarget.style.color='#4B101C';
            }}
            onMouseOut={(e)=>{
              e.currentTarget.style.background='transparent';
              e.currentTarget.style.color='rgba(255,255,255,0.6)';
            }}
            >
              <MessageCircle size={16} />
            </a>

            <a
            
              onMouseOver={(e)=>{
              e.currentTarget.style.background='#C9A96E';
              e.currentTarget.style.color='#4B101C';
            }}
            onMouseOut={(e)=>{
              e.currentTarget.style.background='transparent';
              e.currentTarget.style.color='rgba(255,255,255,0.6)';
            }}
            >
            </a>
          </div>
        </div>

        {[
          {
            title: 'Collections',
            links: [
              ['Rings', '/collections/rings'],
              ['Necklaces', '/collections/necklaces'],
              ['Earrings', '/collections/earrings'],
             
            ],
          },
          {
            title: 'Company',
            links: [
              ['About Us', '/about'],
              ['Contact', '/contact'],
              
            ],
          },
          {
            title: 'Support',
            links: [
              ['My Orders', '/my-orders'],
              ['Returns & Exchange', '#'],
              ['Privacy Policy', '#'],
              ['Terms', '#'],
            ],
          },
        ].map((col) => (
          <div key={col.title}>
            <h4
              style={{
                fontSize: 11,
                letterSpacing: 3,
                textTransform: 'uppercase',
                color: '#C9A96E',
                marginBottom: 16,
              }}
            >
              {col.title}
            </h4>

            {col.links.map(([label, to]) => (
              <Link
                key={label}
                to={to}
                style={{
                  display: 'block',
                  fontSize: 13,
                  opacity: 0.7,
                  marginBottom: 8,
                  color: 'inherit',
                }}
                onMouseOver={(e) => (e.target.style.opacity = 1)}
                onMouseOut={(e) => (e.target.style.opacity = 0.7)}
              >
                {label}
              </Link>
            ))}
          </div>
        ))}
      </div>

      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          borderTop: '1px solid rgba(255,255,255,0.15)',
          paddingTop: 20,
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 12,
          opacity: 0.5,
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        <div className="footer-bottom">



  <div className="border-t border-[#8A4A58] pt-6 mt-8 flex flex-col md:flex-row items-center justify-between">
  <p className="text-sm text-[#D8C7B5]">
    © {new Date().getFullYear()} Anvith Dazzle. All Rights Reserved.
  </p>

  <p className="text-sm text-[#D8C7B5]">
    Designed & Developed by{" "}
    <a
      href="https://webdro26.vercel.app/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-bold text-white hover:text-[#D4AF37] transition-colors duration-300"
        style={{ color: "#ffffff", fontWeight: "700" }}
    >
      WEBDRO
    </a>
  </p>

  <p className="text-sm text-[#D8C7B5]">
   
  </p>
</div>

  
</div>

        <span>Luxury Jewellery • Crafted in Nellai • Since 2025</span>
      </div>

      <style>{`
        @media(max-width:768px){
          footer > div:first-child {
            grid-template-columns: 1fr 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}